import logger from '../../Vendor/inv-logger/logger';

const appealPublicReferenceElement = document.getElementById('data-appeal-public-reference');

if (!appealPublicReferenceElement) {
  logger.logAndThrowUntranslatedError('Unable to read the appeal public reference');
}

const appealPublicReference = appealPublicReferenceElement.getAttribute('data-value');

export default {
  appealPublicReference: appealPublicReference
};
